import React from 'react';
import { BookingDrawerContentType } from './types';
import { Box, Drawer } from '@good/ui/core';
import { BookingDrawerContent } from './booking-drawer-content';
import { ROSTER_TAB } from '../bookings-roster-view/components/roster-common-enums';
import { useBookings } from './bookings-view-context';

interface BookingDrawerProps {
  opened: boolean;
  onChangeCanCloseDrawer: (canClose: boolean) => void;
  onClose: () => void;
  size: string;
  refreshAndClose: () => void;
  selectedType: BookingDrawerContentType | null;
  selectedTab: ROSTER_TAB | null;
}

export const BookingDrawer = ({
  onChangeCanCloseDrawer,
  opened,
  onClose,
  size,
  refreshAndClose,
  selectedType,
  selectedTab,
}: BookingDrawerProps) => {
  const selectedRosterItem = useBookings((state) => state.selectedRosterItem);

  return (
    <Drawer.Root
      opened={opened}
      onClose={onClose}
      lockScroll={false}
      position='right'
      shadow='none'
      closeOnClickOutside
      padding={0}
      size={size}
    >
      <Drawer.Content>
        <Drawer.Body
          h='100%'
          display='flex'
          style={{ flexDirection: 'column', borderLeft: '1px solid var(--mantine-color-gray-4)' }}
        >
          <Box pos='sticky' top={0} p='md' w='100%' style={{ zIndex: 10 }}>
            <Drawer.CloseButton />
          </Box>
          <BookingDrawerContent
            selectedRosterItem={selectedRosterItem}
            setCanCloseDrawer={onChangeCanCloseDrawer}
            refreshAndCloseData={refreshAndClose}
            type={selectedType}
            rosterTab={selectedTab}
          />
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};
